// extracted by mini-css-extract-plugin
export default {"popupContent":"PopupHintWrapper_popupContent__21pyp","popupParagraph":"PopupHintWrapper_popupParagraph__48o8s"};